import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { getFormValues } from 'redux-form'
// components
import Grid from '@mui/material/Grid2'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// views
import { ChangedLabel, FloatingBottomPaper } from './views'
// utils
import pluralize from 'pluralize'
import { handleError } from 'utils/errors/handlers'

interface Props {
  form?: string
  valid?: boolean
  onCancel: () => void
  className?: string
  dirtyCount: number
  submitting?: boolean
  isCreateForm?: boolean
  handleConfirm?: (formValues: any) => Promise<void>
  justifyContent?: any
}

const FloatingActions: React.FC<Props> = ({
  form,
  valid,
  onCancel,
  className,
  dirtyCount,
  submitting,
  isCreateForm,
  handleConfirm,
  justifyContent = 'flex-start'
}) => {
  const [isLoading, setLoading] = React.useState(false)

  const { formValues } = useSelector((state) => ({
    formValues: getFormValues(form)(state)
  }))

  const handleConfirmClick = async () => {
    try {
      if (!handleConfirm) {
        return
      }

      setLoading(true)
      await handleConfirm(formValues)
    } catch (errors) {
      handleError(errors, 'FloatingActions.handleConfirmClick')
    } finally {
      setLoading(false)
    }
  }

  const buttonLabel = isCreateForm ? 'Create' : 'Save'

  return (
    (!!dirtyCount || !!isCreateForm) && (
      <FloatingBottomPaper className={className}>
        <Grid container spacing={2} justifyContent={justifyContent}>
          <Grid>
            <Button
              type='submit'
              onClick={handleConfirmClick}
              layout={BUTTON_LAYOUTS.PURPLE}
              disabled={isCreateForm && !valid}
              isLoading={isLoading || submitting}>
              {buttonLabel}
            </Button>
          </Grid>
          <Grid>
            <Button layout={BUTTON_LAYOUTS.WHITE} type='button' onClick={onCancel}>
              Cancel
            </Button>
          </Grid>
          {!isCreateForm && (
            <Grid>
              <ChangedLabel>{`You've changed ${dirtyCount} ${pluralize('property', dirtyCount)}`}</ChangedLabel>
            </Grid>
          )}
        </Grid>
      </FloatingBottomPaper>
    )
  )
}

export default FloatingActions
